export default "__VITE_ASSET__BuGsifBL__"